module.exports = __webpack_public_path__ + "img/mi.d5020879.jpg";